require('./bootstrap');

import Vue from "vue";
import Router from 'vue-router';

// import { createPinia, mapStores } from 'pinia';
// import VueCompositionAPI from '@vue/composition-api';
// import router from './router';

import VueAgile from "vue-agile";
import GLightbox from 'glightbox';

// import GLightbox styles
import 'glightbox/dist/css/glightbox.min.css';

// Vee Validate
import {extend, localize, ValidationObserver, ValidationProvider, Validator} from 'vee-validate';
import en from './Components/FormBuilder/validation.json';
import * as rules from 'vee-validate/dist/rules';

import App from "./App.vue";
import FormBuilder from "./Components/FormBuilder";
import Search from './Components/Search';
import VueFreeform from './Components/Form';

import router from './router';
// const pinia = createPinia();

// Vue.use(router);
// Vue.use(VueCompositionAPI);

import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

const pinia = createPinia()
pinia.use(piniaPersist)

Vue.use(pinia)
Vue.use(PiniaVuePlugin)

Vue.use(Router);
Vue.use(VueAgile);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.config.devtools = true;

Vue.component('App', App);
Vue.component('form-builder', FormBuilder);
Vue.component('search', Search);
Vue.component('vue-freeform', VueFreeform);

window.Vue = require("vue");

import VueSlider from "vue-slider-component";

import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

import VueAwesomeSwiper from "vue-awesome-swiper";

import "swiper/css";

Vue.use(VueAwesomeSwiper);

window.Swiper = Swiper;
window.Swiper.use(Scrollbar);
window.Swiper.use(Navigation);

Vue.component("VueSlider", VueSlider);
const fileLengthParams = ['min', 'max'];
const fileLengthFunc = (value, { min, max } = {}) => {
    return Number(min) <= value.length && Number(max) >= value.length;
};
localize({
    en
});

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
extend('fileLength', {validate: fileLengthFunc, params: fileLengthParams});

/*jquery */

import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;

// vue
window.VueApp = new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    router,
    pinia,
    data: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        city: '',
        state: '',
        jobRole: '',
        preferredPlatform: '',
        typeOfEnquiry: '',
        enquiry: '',
        streetAddress: '',
        zipCode: '',
        errors: [],
        heroCardSlider: {
            slidesPerView: 4,
            spaceBetween: 10,
            pagination: false,
            dots: false,
            centeredSlides: false,
            loop: false,
            breakpoints: {
                320: {
                    slidesPerView: 2.25,
                    spaceBetween: 8,
                },
                768: {
                    slidesPerView: 2.25,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
            },
        },
        relatedSliderBlockSlider: {
            slidesPerView: 1,
            pagination: false,
            dots: false,
            centeredSlides: true,
            loop: true,
            breakpoints: {
                400: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1400: {
                    slidesPerView: 3,
                },
                1920: {
                    slidesPerView: 3.5,
                },
                4000: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: ".relatedSlider-block-slider-next",
                prevEl: ".relatedSlider-block-slider-prev"
            },
        },
        productSliderBlockSlider: {
            slidesPerView: 1,
            pagination: false,
            dots: false,
            centeredSlides: true,
            loop: true,
            breakpoints: {
                400: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1400: {
                    slidesPerView: 3,
                },
                1920: {
                    slidesPerView: 3.5,
                },
                4000: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: ".productSlider-block-slider-next",
                prevEl: ".productSlider-block-slider-prev"
            },
        },
        videoGuidesCarouselBlockSlider: {
            slidesPerView: 1,
            pagination: false,
            dots: false,
            centeredSlides: true,
            loop: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                400: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1400: {
                    slidesPerView: 3,
                },
                1920: {
                    slidesPerView: 3.5,
                },
                4000: {
                    slidesPerView: 3.5,
                },
            },
            navigation: {
                nextEl: ".videoGuidesCarousel-block-slider-next",
                prevEl: ".videoGuidesCarousel-block-slider-prev"
            },
        },
        howToVideoCarouselBlockSlider: {
            slidesPerView: 1,
            pagination: false,
            dots: false,
            centeredSlides: true,
            loop: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                400: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1400: {
                    slidesPerView: 3,
                },
                1920: {
                    slidesPerView: 3.5,
                },
                4000: {
                    slidesPerView: 3.5,
                },
            },
            navigation: {
                nextEl: ".howToVideoCarousel-block-slider-next",
                prevEl: ".howToVideoCarousel-block-slider-prev"
            },
        },
        testimonialsBlockSlider: {
            slidesPerView: 1.3,
            pagination: false,
            dots: false,
            centeredSlides: true,
            loop: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                400: {
                    slidesPerView: 1.3,
                },
                650: {
                    slidesPerView: 1.3,
                },
                991: {
                    slidesPerView: 1.3,
                },
                1100: {
                    slidesPerView: 1.3,
                },
                1400: {
                    slidesPerView: 1.5,
                },
                1700: {
                    slidesPerView: 1.5,
                },
                1920: {
                    slidesPerView: 1.6,
                },
                2200: {
                    slidesPerView: 1.7,
                },
                2500: {
                    slidesPerView: 1.8,
                },
                3000: {
                    slidesPerView: 1.9,
                },
            },
            navigation: {
                nextEl: ".testimonials-block-slider-next",
                prevEl: ".testimonials-block-slider-prev"
            },
        },
        showOverlay: false,
        /* Header */
        mobileMenuActive: false,
		currentLevel: 0,
        activeIndex: null,
        activeSubIndex: null,
		parentLevelTitle: '',
        mainNavDropdown       : false,
		timer                 : null,
		hoverEnterTime        : 100,
		hoverLeaveTime        : 100,
		currentSubMenu		  : null,
		currentSubSubMenu	  : null,
		headerHovered: false,
        mobileSearchActive: false,
        languagesActive: false,
        activeAccorionIndex: null,
        /* Search */
        searchQuery: '',
		searchResults: [],
    },
    methods: {
        /* Nav */
        showSubMenu(event, slug) {
            clearTimeout(this.timer);
            this.mainNavDropdown = true;
			this.headerHovered = true;
			this.currentSubMenu = slug;
			this.adjustSubNavHeight();
			document.body.classList.add('ns');

            // Hide mobile menu if 'search-visible' is clicked
            if (slug === 'search-visible') {
                this.mobileMenuActive = false;
            }
        },
        hideSubMenu() {
            clearTimeout(this.timer);
			this.mainNavDropdown = false;
			this.headerHovered = false;
			this.currentSubMenu = null;
			this.resetNavItems();
			document.body.classList.remove('ns');
            this.isSearchVisible = false;

            this.currentLevel = 0;
            this.activeIndex = null;
            this.parentLevelTitle = '';
        },
        onFocusOut(event) {
            // Check if the newly focused element is outside of the mainNavDropdown
            if (!this.$refs.mainNavDropdown.contains(event.relatedTarget)) {
              this.hideSubMenu();
            }
        },
		handleKeyDown(event, slug) {
            if (['Enter', ' ', 'Escape'].includes(event.key)) {
                event.preventDefault();
                if (event.key === 'Escape') {
                    this.hideSubMenu();
                    this.deactivateSearch();
                } else {
                    this.showSubMenu(event, slug);
                }
            }
        },
		resetNavItems(){
			const navItemsWithChildren = document.querySelectorAll('.main-nav > .has-sub-nav');
			navItemsWithChildren.forEach(navItem => {
				const firstChild = navItem.querySelector('.main-nav__subnav-menu > li');
				if (firstChild) {
					firstChild.classList.add('is-active');
				}
			});
		},
		toggleMobileMenu: function() {
            this.mobileMenuActive = !this.mobileMenuActive;
        
            if (this.mobileMenuActive) {
                this.activeIndex = null;
                this.currentSubMenu = null;  // This hides the search or any other active submenus
                this.headerHovered = false;  // Remove hover state from the header
                this.mobileSearchActive = false;  // Deactivate mobile search state
                document.body.classList.add('ns');  // Add class to body when mobile menu is active
            } else {
                document.body.classList.remove('ns');  // Remove class when mobile menu is inactive
                this.activeIndex = null;
                this.currentLevel = 0;
                this.activeIndex = null;
				this.parentLevelTitle = '';
            }
        },
		navigateToLevel(level, index, parentTitle) {
            if (level === 1) {
                this.currentLevel = 1;
                this.activeIndex = index;
				this.parentLevelTitle = parentTitle;
            } else if (level === 2) {
                this.currentLevel = 2;
                this.activeSubIndex = index;
				this.parentLevelTitle = parentTitle;
            }
        },
        navigateBack() {
            if (this.currentLevel === 2) {
                this.currentLevel = 1;
                this.activeSubIndex = null;
            } else if (this.currentLevel === 1) {
                this.currentLevel = 0;
                this.activeIndex = null;
				this.parentLevelTitle = '';
            }else{
				this.languagesActive = false;
			}
        },
		adjustSubNavHeight() {
            const subNavInner = document.querySelector('.main-nav__subnav-inner');
            const menuContentFirstDiv = document.querySelector('.main-nav__subnav-menu > li.is-active .main-nav__subnav-inner-wrap');
            if (subNavInner && menuContentFirstDiv) {
				subNavInner.style.height = menuContentFirstDiv.offsetHeight + 'px';
            }
			else {
				subNavInner.style.height = 'auto';
			}
        },
        toggleSubnavAccordion(event) {
            // Extract the index from the clicked element's data-index attribute
            const index = parseInt(event.target.getAttribute('data-index'), 10);
            // Toggle the accordion content
            this.activeAccorionIndex = this.activeAccorionIndex === index ? null : index;
        },

        /* Search */
        getQueryParam(name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
          },
        fetchSearchResults() {

			if (this.searchQuery == '') {
				this.searchResults = [];
			} else {
				const apiUrl = `${window.location.origin}/search.json?q=${this.searchQuery}`;

				axios.get(apiUrl)
					.then(response => {
						this.searchResults = response.data.data;
					})
					.catch(error => {
						this.fetchSearchResults = error;
					});
			}
		},
        clearSearchQuery() {
            this.searchQuery = '';
            this.searchResults = [];
            this.$router.push({ query: null });
        }
    },
    mounted: function() {
		this.resetNavItems();
        this.activeAccorionIndex = null;
    },
    created() {
        // Initialize `searchQuery` here
        this.searchQuery = this.getQueryParam('q') || '';
      },
    watch: {
        fetchSearchResults: 'fetchSearchResults',
    },
    computed: {
        isMobileSubActive() {
            return this.currentSubMenu === 'search-visible' && window.innerWidth <= 1023;
        }
    }

  });

// Mobile Menu
// const toggleButtons = document.querySelectorAll('[data-toggle]');

// toggleButtons.forEach(function (toggleButton) {
//     toggleButton.addEventListener('click', function() {
//         var content = this.getAttribute('data-toggle');
//         document.getElementById(content).classList.toggle("is-active");
//         this.classList.toggle("is-active");
//         document.body.classList.toggle("ns");
//     });
// });

// $('header button[data-toggle="mobile-menu"]').on('click', function(){
//     $('#alert-banner').toggle();
// })

//Subnav

// $('.js-has-nav-mob-button').on('click', function(e){
//     e.preventDefault();
//     $(this).parents('.has-descendants').toggleClass('is-active');
//     $(this).parents('.has-descendants').find('ul').slideToggle();
// });

// $('.mobile-menu ul li a').on('click', function() {
//     $(this).toggleClass('is-hover');
// });

// Tabs
var myTabs = document.querySelectorAll(".tab-nav__link");
var myTabsContent = document.querySelectorAll(".tab-content");
var t;
var i = 0;
for (i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener("click", function(e) {
        var tab = this.getAttribute("data-tab");

        for (t = 0; t < myTabsContent.length; t++) {
            myTabsContent[t].classList.remove("is-active");
            myTabs[t].classList.remove("is-active");
        }

        this.classList.add("is-active");
        document.getElementById(tab).classList.add("is-active");
        return false;
        e.preventDefault();
    });
}

// Cookie Functions
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
}


// Alert Banner
var close_alert_banner = document.getElementById("js-close-alert-banner");
var alert_banner = document.getElementById("alert-banner");
var alert_banner_cookie = getCookie("alert-banner-cookie");
if (alert_banner_cookie && alert_banner) {
    if (alert_banner.classList) {
        alert_banner.classList.remove("is-active");
    }
}
if (!alert_banner_cookie) {
    if (document.body.classList) {
        document.body.classList.add("banner-active");
    }
}
if (close_alert_banner) {
    close_alert_banner.addEventListener("click", function() {
        if (alert_banner.classList) {
            alert_banner.classList.remove("is-active");
        }
        if (document.body.classList) {
            document.body.classList.remove("banner-active");
        }
        setCookie("alert-banner-cookie", "1");
    });
}

// Accordion

$('.accordion-block-items>li').on('click', function(){
    $(this).find('p').slideToggle();
    $(this).find('ul').slideToggle(function() {
        $(this).find('li').css('display', 'list-item');
    });
    $(this).find('.accordion-block-item-toggle').toggleClass('rotated');
});

// Dynamic height header nav

jQuery(document).ready(function($) {
    // When the window resizes
   $(window).on('resize', function () {

       var headerHeight = $('.header').outerHeight();
       var alertBanner = $('#alert-banner').outerHeight();

       if($('#alert-banner').is(':visible')){
           $('header').css('top', alertBanner);
           $('.header .header-nav .dropdown').css('top', headerHeight - 30);
           $('#block-index-1').css('margin-top', headerHeight + alertBanner);
       }
       else{
        $('header').css('top', 0);
        $('.header .header-nav .dropdown').css('top', headerHeight - 30);
        $('#block-index-1').css('margin-top', headerHeight);
       }

   });

   $('.alert-banner__close').on('click', function(){
    var headerHeight = $('.header').outerHeight();
    $('header').css('top', 0);
    $('.header .header-nav .dropdown.active').css('top', headerHeight - 30);
    $('#block-index-1').css('margin-top', headerHeight);
   });

    // Trigger the function on document load.
   $(window).trigger('resize');
});

const lightbox = GLightbox({
    selector: '.glightboxVideo',
    touchNavigation: false,
    autoplayVideos: true,
    draggable: false,
    onOpen: () => {
        console.log("Lightbox opened");
    },
    beforeSlideLoad: (slide, data) => {
        // Need to execute a script in the slide?
        // You can do that here...
    }
});

// const nav = () => {
//     const navigation = document.querySelector('.header');
//     const dropdownTriggers = document.querySelectorAll('.has-dropdown');
//     const dropdowns = document.querySelectorAll('.dropdown');

//     function resetDropdowns() {
//         dropdownTriggers.forEach(trigger => trigger.classList.remove('active'))
//         dropdowns.forEach(dropdown => dropdown.classList.remove('active'))
//     }

//     dropdowns.forEach((trigger) => {
//         trigger.addEventListener('mouseleave', (e) => {
//             e.preventDefault();
//             if(trigger.classList.contains('active')) {
//                 resetDropdowns();
//             }
//         })
//     });

//     dropdownTriggers.forEach((trigger) => {
//         trigger.addEventListener('mouseenter', (e) => {
//             e.preventDefault();
//             if(trigger.classList.contains('active')) {
//                 resetDropdowns();
//             } else {
//                 resetDropdowns();
//                 trigger.classList.add('active');
//                 trigger.nextElementSibling.classList.add('active');
//             }
//         })
//     });

//     dropdownTriggers.forEach((trigger) => {
//         trigger.addEventListener('mouseleave', (e) => {
//             e.preventDefault();
//             if(!trigger.classList.contains('active')) {
//                 resetDropdowns();
//             }
//         })
//     });

//     document.body.addEventListener('click', (e) => {
//         if(document.querySelector('.dropdown.active')) {
//             const clickedElement = e.target;

//             if (
//                 !clickedElement.classList.contains('active')
//                 && !clickedElement.classList.contains('cera700')
//                 && !clickedElement.classList.contains('js-do-not-close-dd-onclick')
//             ) {
//                 resetDropdowns()
//             }
//         }
//     });

//     document.body.addEventListener('mouseover', (e) => {
//         if(document.querySelector('.js-has-no-dropdown')) {
//             const hoveredElement = e.target;
//             if (
//                 hoveredElement.classList.contains('js-has-no-dropdown')
//             ){
//                 resetDropdowns()
//             }
//         }
//     });

// }

// nav();

// Get all site switchers

const siteSwitchers = document.querySelectorAll('.site-switcher');

if (siteSwitchers.length > 0) {
    siteSwitchers.forEach(el => {
    const toggleSwitcher = function() {
        if (el.querySelector('.site-switcher__sites')) {
        el.querySelector('.site-switcher__button').classList.toggle('site-switcher__button--active');
        el.querySelector('.site-switcher__sites').classList.toggle('site-switcher__sites--visible');
        }
    };
    el.addEventListener('click', toggleSwitcher);
    });
}

const countryNotice = () => {
    if (document.getElementById('geomate-country')) {
        let countryPreference = localStorage.getItem('countryPreference');
        let bannerActioned    = localStorage.getItem('bannerActioned');
        const geomateCountry  = document.getElementById('geomate-country').textContent.trim();

        // Show banner if it hasn't been actioned
        if (bannerActioned === null) {
            $('#country-modal').addClass('is-active');
        }

        function setCountryPreference(country)
        {
            localStorage.setItem('countryPreference', country);
        }

        // banner
        $('.accept-country-notice').on('click', function(e){
            e.preventDefault();
            localStorage.setItem('bannerActioned', true);
            location.assign($(this).attr('href'));
            return false;
        });

        $('.country-modal-continue').on('click', function(){
            $('#country-modal').removeClass('is-active');
            localStorage.setItem('bannerActioned', true);
            return false;
        });

        $('.country-modal-close').on('click', function(){
            $('#country-modal').removeClass('is-active');
            localStorage.setItem('bannerActioned', true);
        });

        countryPreference = ((countryPreference != null && countryPreference != 'null') ? countryPreference : geomateCountry);

        setCountryPreference(countryPreference);

        console.log(countryPreference);
        console.log(geomateCountry);

        // hide banner if its already been actioned
        if (bannerActioned != null && bannerActioned == 'true')
        {
            $('#country-modal').removeClass('is-active');
        }
    }
}

countryNotice();
